import { z } from 'zod'

export const developmentEnv = {
  server: {
    DATABASE_URL: z.string().url().optional(),

    // PostgreSQL Database in Docker
    POSTGRES_URL: z
      .string()
      .url()
      .optional()
      .default('postgres://postgres:postgres@localhost:5432/algoacademy'),
    POSTGRES_USER: z.string().optional(),
    POSTGRES_PASSWORD: z.string().optional(),
    POSTGRES_DB: z.string().optional(),
    POSTGRES_PORT: z.string().optional(),

    // Neon Database (legacy, kept for backwards compatibility)
    NEON_DATABASE_URL: z.string().url().optional(),

    // Authentication
    BETTER_AUTH_SECRET: z.string().min(32),
    BETTER_AUTH_URL: z.string().url().optional(),

    // OAuth
    AUTH_GITHUB_ID: z.string().optional(),
    AUTH_GITHUB_SECRET: z.string().optional(),
    AUTH_GOOGLE_ID: z.string().optional(),
    AUTH_GOOGLE_SECRET: z.string().optional(),
    AUTH_DISCORD_ID: z.string().optional(),
    AUTH_DISCORD_SECRET: z.string().optional(),

    // Storage
    UPLOADTHING_TOKEN: z.string().optional(),

    // Brevo
    BREVO_API_KEY: z.string().optional(),

    // Stripe
    STRIPE_SECRET_KEY: z.string().optional(),
    STRIPE_WEBHOOK_SECRET: z.string().optional(),

    // Algolia
    ALGOLIA_WRITE_API_KEY: z.string().optional(),

    // Other
    ALGO_EMAIL: z.string().email().optional(),
    ALGO_PHONE_NUMBER: z.string().optional()
  },

  client: {
    NEXT_PUBLIC_API_URL: z.string().url().default('http://localhost:3000/api/trpc'),

    // Algolia Search
    NEXT_PUBLIC_ALGOLIA_APP_ID: z.string().optional(),
    NEXT_PUBLIC_ALGOLIA_SEARCH_KEY: z.string().optional(),
    NEXT_PUBLIC_ALGOLIA_INDEX: z.string().optional()
  },

  experimental__runtimeEnv: {
    NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
    NEXT_PUBLIC_ALGOLIA_APP_ID: process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
    NEXT_PUBLIC_ALGOLIA_SEARCH_KEY: process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY,
    NEXT_PUBLIC_ALGOLIA_INDEX: process.env.NEXT_PUBLIC_ALGOLIA_INDEX
  },

  skipValidation: !!process.env.SKIP_ENV_VALIDATION
}
